<template>
	<div style="position: relative;">
		<slot :list="dataList"></slot>
		<slot name="append"></slot>
	</div>
</template>

<script>
	export default {
		props: {
			value: [Array],
			
			disabled: Boolean
		},
		
		data() {
			return {
				drawId: 1,
				dataList: [],
				translate: {
					x: 0,
					y: 0
				}
			}
		},
		
		watch: {
			value() {
				this.update();
			},
			
			disabled(val) {
				this.$children.forEach(item => item.disabled = val);
			}
		},
		
		mounted() {
			this.update();
		},
		
		methods: {
			update() {
				this.dataList = Array.from(this.value, (item, key) => {
					return {
						key,
						item
					}
				});
			},
			
			updateTranslate(seat) {
				this.translate = seat;
			},
			
			sortHandle(index, target) {
				var item = this.dataList.splice(index, 1)[0];
				this.dataList.splice(target, 0, item);
			},
			
			sortEnd() {
				this.$emit('input', Array.from(this.dataList, item => item.item));
			}
		}
	}
</script>
